<div class="center-container" *ngIf="config.isCxOne && !isLoadingProdAndCat">
	<page-error-state *ngIf="config.isCxOne && !isLoadingProdAndCat" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission('READ')" pageName="Marketplace_Management"></page-error-state>
</div>
<div [ngClass]="!config.isCxOne ? 'marketplace-admin-main' : 'marketplace-admin-main container bg-none'">
	<div>
		<!-- cxone loader -->
		<div class="center-container" *ngIf="((isLoadingProdAndCat || !pspes.collection.originalData) && !showOrders)">
			<cv-loader [ngStyle]="!config.isCxOne ? { top: '50%', position: 'absolute', left: '50%'} : {}" [size]="'large'" [loaderType]="config.isCxOne ? 'cxone' : 'clearview'" [overlay]="true"></cv-loader>
		</div>
		<!-- end cxone loader -->
		<div class="row">
			<div class="col-12 pb-1">
				<ng-container *ngIf="!config.isCxOne">
					<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs pt-2">
						<li [ngbNavItem]="1" (shown)="toggleOrders(false)">
							<a ngbNavLink><span cvLocalizedText
									langSection="MarketPlace_Management" langKey="Products">Products</span></a>
							<ng-template ngbNavContent>
								<div class="row">
									<div class="col-12 my-2">
										<div [hidden]="!(showOrders == false)">
											<div class="row">
												<div class="col-sm-8 d-flex">
													<button type="button" class="btn btn-primary"
														[hidden]="showOrders == true"
														[ngClass]="!hasPermission('CREATE') ? 'opacity-5 cursor-default' : ''"
														(click)="!hasPermission('CREATE') ? $event.stopPropagation() : addProduct();">
														<svg class="icon-16">
															<use
																href="../../../App_Themes/clearview-default/icons/utility/add.svg#add">
															</use>
														</svg>
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="New_Product">New Product</span>
													</button>
													<div class="search-box live-search  w-50 ml-3"
														[hidden]="!(showOrders == false)">
														<input type="search" class="form-control form-control-lg"
															[placeholder]="searchPlaceholder"
															[(ngModel)]="pspes.pointStoreProductFilter.Title"
															(ngModelChange)="filterChanged()"
															(ngModelChangeDebounced)="pspes.pointStoreProductFilter.Title"
															[ngModelChangeDebounceTime]="400" [maxlength]="50"
															maxlength=50 />
														<span class="clear-input"
															[hidden]="!(pspes.pointStoreProductFilter.Title.length > 0)"
															(click)="clearSearch()"></span>
													</div>
												</div>
												<div class="col-sm-4 dropdown d-flex justify-content-end">
													<button type="button" class="btn btn-text dropdown-toggle mr-2"
														[hidden]="showOrders == true" (click)="toggleFilters()">
														<svg class="icon-16 fill-cerulean">
															<use
																href="../../../App_Themes/clearview-default/icons/utility/filter.svg#filter">
															</use>
														</svg>
														<span class="caret" cvLocalizedText
															langSection="MarketPlace_Management"
															langKey="Filter">Filter</span>
													</button>

													<div class="btn-group shadow-none card-table-selector hide d-none"
														[hidden]="!(showOrders == false)">
														<label
															class="btn btn-secondary btn-toggle-view ag-theme-material d-flex align-items-center"
															[ngClass]="view == 0 ? 'active' : ''"
															(click)="setThumbnailView()">
															<span class="ag-icon ag-icon-columns mx-auto"></span>
														</label>

														<label
															class="btn btn-secondary btn-toggle-view ag-theme-material d-flex align-items-center"
															[ngClass]="view == 1 ? 'active' : ''"
															(click)="setListView()">
															<span class="ag-icon ag-icon-menu mx-auto"></span>
														</label>
													</div>
												</div>
												<div class="col-12">
													<p></p>
												</div>
											</div>
											<div class="row">
												<div class="col-8 offset-4 d-flex test-filters"
													*ngIf="showFilters == true">
													<div
														class="form-group d-flex col-6 m-0 p-0 align-items-end justify-content-end">
														<div class="form-check form-check-inline flex-shrink-0">
															<input class="form-check-input" type="checkbox" value=""
																id="filterSale"
																[(ngModel)]="pspes.pointStoreProductFilter.Sale"
																(ngModelChange)="filterChanged()" />
															<label class="form-check-label" for="filterSale">
																<span cvLocalizedText
																	langSection="MarketPlace_Management"
																	langKey="On_Sale">On Sale</span>
															</label>
														</div>
														<div class="form-check form-check-inline flex-shrink-0">
															<input class="form-check-input" type="checkbox" value=""
																id="filterFeatured"
																[(ngModel)]="pspes.pointStoreProductFilter.Feature"
																(ngModelChange)="filterChanged()" />
															<label class="form-check-label" for="filterFeatured">
																<span cvLocalizedText
																	langSection="MarketPlace_Management"
																	langKey="Is_Featured">Is Featured</span>
															</label>
														</div>
														<div class="form-check form-check-inline flex-shrink-0">
															<input class="form-check-input" type="checkbox" value=""
																id="filterCarousel"
																[(ngModel)]="pspes.pointStoreProductFilter.Carousel"
																(ngModelChange)="filterChanged()" />
															<label class="form-check-label" for="filterCarousel">
																<span cvLocalizedText
																	langSection="MarketPlace_Management"
																	langKey="On_Carousel">On Carousel</span>
															</label>
														</div>
													</div>
													<div class="col-6 p-0 d-flex">
														<div class="form-group mb-0 w-50">
															<label class="py-0 col-form-label font-size-12"
																cvLocalizedText langSection="MarketPlace_Management"
																langKey="Category">Category</label>
															<div>
																<select class="form-control w-100 mr-2"
																	[(ngModel)]="selectedCategory"
																	(ngModelChange)="categorySelected()">
																	<option *ngFor="let cat of pscs.categoryMap"
																		[ngValue]="cat">{{cat.m_Item1}}</option>
																</select>
															</div>
														</div>

														<div class="form-group mb-0 w-50 pl-2">
															<label class="py-0 col-form-label font-size-12"
																cvLocalizedText langSection="MarketPlace_Management"
																langKey="Sub_Category">Sub-Category</label>
															<div>
																<select class="form-control w-100"
																	[(ngModel)]="pspes.pointStoreProductFilter.SubCategory"
																	(ngModelChange)="filterChanged()">
																	<option
																		*ngFor="let subCat of selectedSubCategories">
																		{{subCat}}</option>
																</select>
															</div>
														</div>
													</div>
												</div>
											</div>
											<cv-point-store-product-landing-thumbnail
												[productList]="pspes.collection.originalData"
												[sortOptions]="sortOptions"
												*ngIf="pspes.collection.originalData != null && view == 0"></cv-point-store-product-landing-thumbnail>
											<cv-point-store-product-landing-list
												*ngIf="pspes.collection.originalData != null && view == 1"></cv-point-store-product-landing-list>
											<!--<point-store-product-landing-list remove="removeListView();" ng-if="view == 1"></point-store-product-landing-list>-->
										</div>
										<!--<point-store-product-orders-admin-list ng-show="showOrders == true"></point-store-product-orders-admin-list>-->
									</div>
								</div>
							</ng-template>
						</li>
						<li [ngbNavItem]="2" (shown)="toggleOrders(true)">
							<a ngbNavLink><span cvLocalizedText langSection="MarketPlace_Management"
									langKey="Order_Management">Order Management</span></a>
							<ng-template ngbNavContent>
								<div class="row">
									<div class="col-12 pt-2">
										<div class="row pt-0">
											<div class="col-6">
												<div class="row">
													<div class="form-group col-5">
														<label cvLocalizedText langSection="MarketPlace_Management" langKey="Orders_Placed_In">Orders Placed In</label>
														<select class="form-control"
															(ngModelChange)="loadPointStoreProductAdminOrders()"
															[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.datePosition">
															<option
																*ngFor="let date of pspos.pointStoreProductAdminOrderFilter.date"
																[value]="date.position">
																<label cvLocalizedText
																	langSection="MarketPlace_Management_Filter"
																	langKey="{{date.keyLocalization}}">{{ date.name
																	}}</label>
															</option>
														</select>
													</div>
													<div class="form-group col-4 p-0">
														<label cvLocalizedText langSection="Order_Management"
															langKey="Status">Status</label>
														<cv-multi-select [id]="'statusDropdown'" [value]="status"
															[autoWidth]="true" [placeholder]="getLocalizationString('None_Selected_Placeholder', 'None Selected')"
															[options]="pspos.OrderStatus" (selectionChanged)="onMultiSelectValueChanged($event)"
															primaryKey="value" label="name"
															[selectionText]="showText"
															(closed)="onSelectorClose()"></cv-multi-select>
													</div>
												</div>
											</div>
											<div class="form-group col-6">
												<label cvLocalizedText langSection="MarketPlace_Management" langKey="Select_Group">Select Group</label>
												<cv-point-store-product-group-selector></cv-point-store-product-group-selector>
											</div>
										</div>
										<div class="form-group row m-0">
											<div class="col-sm-7 hidden">
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterPending"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.Processing" />
													<label class="form-check-label" for="filterPending">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Processing">Processing</span>
													</label>
												</div>
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterInTransit"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.InTransit" />
													<label class="form-check-label" for="filterInTransit">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Intransit">In transit</span>
													</label>
												</div>
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterReadyForPickUp"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.ReadyForPickUp" />
													<label class="form-check-label" for="filterReadyForPickUp">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Ready_For_Pickup">Ready for pick-up</span>
													</label>
												</div>
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterComplete"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.Complete" />
													<label class="form-check-label" for="filterComplete">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Complete">Complete</span>
													</label>
												</div>
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterCancel"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.Cancelled" />
													<label class="form-check-label" for="filterCancel">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Cancelled">Cancelled</span>
													</label>
												</div>
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" value=""
														id="filterShipped"
														[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.Shipped" />
													<label class="form-check-label" for="filterShipped">
														<span cvLocalizedText langSection="MarketPlace_Management"
															langKey="Shipped">Shipped</span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- Order SearchBar and Export -->
								<div class="row">
									<div class="col-12 d-flex p-0">
										<div class="col-6">
											<div class="search-box live-search  w-75">
												<input type="search" class="form-control" cvLocalizedPlaceholder
													langSection="MarketPlace_Management" langKey="Search_Orders"
													[(ngModel)]="pspos.pointStoreProductAdminOrderFilter.searchOrder"
													(ngModelChangeDebounced)="pspos.pointStoreProductAdminOrderFilter.searchOrder"
													[ngModelChangeDebounceTime]="400" data-ng-maxlength="50"
													maxlength=50 />
												<span class="clear-input"
													[hidden]="!(pspos.pointStoreProductAdminOrderFilter.searchOrder.length > 0)"
													(click)="clearSearch()"></span>
											</div>
										</div>
										<div class="col-6 text-right">
											<div class="pointStoreExportIcon"
												(click)="assignNotifications(notificationModal)">
												<svg class="icon-16 fill-cerulean">
													<use
														href="../../../App_Themes/clearview-default/icons/utility/notification.svg#notification">
													</use>
												</svg>
											</div>
											<div [style]="pspos.isloadingExternalFilter ? 'pointer-events: none;': ''"
												class="pointStoreExportIcon" (click)="exportOrdersTable()">
												<svg class="icon-16 fill-cerulean">
													<use
														href="../../../App_Themes/clearview-default/icons/utility/export.svg#export">
													</use>
												</svg>
											</div>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12 my-2">
										<cv-point-store-orders-admin></cv-point-store-orders-admin>
										<!--<point-store-product-orders-admin-list ng-show="ctrlPointStoreProductLandingPage.showOrders == true"></point-store-product-orders-admin-list>-->
									</div>
								</div>
							</ng-template>
						</li>
					</ul>
					<div [ngbNavOutlet]="nav" class="mt-2 border-top-0"></div>
				</ng-container>
				<!-- cxone container -->
				<div *ngIf="config.isCxOne && hasPermission('READ') && !noPMLicense" class="cxone-container">
					<!-- Header -->
					<div class="d-flex align-items-end justify-content-between custom-row py-3">
						<div class="marketplaceManagementHeader text-padding" aria-labelledby="MarketplaceManagementHeader">
							<h1 class="text-nowrap marketplaceManagementHeaderText h1-ellipsis" role="heading" cvLocalizedText
								langSection="MarketPlace_Management" langKey="MarketPlace_Management" aria-level="1"
								id="MarketplaceManagementHeader" [tooltip]="showTooltipFunction()"
                                containerClass="tooltip-container">
								Marketplace Management 
							</h1>
						</div>
						<div class="d-flex flex-container">
							<button type="button" class="cxone-btn btn-big btn-primary" [hidden]="showOrders == true"
								[ngClass]="(!hasPermission('CREATE')|| ((isLoadingProdAndCat || !pspes.collection.originalData) && !showOrders)) ? 'opacity-5 cursor-default' : ''"
								(click)="(!hasPermission('CREATE') || ((isLoadingProdAndCat || !pspes.collection.originalData) && !showOrders)) ? $event.stopPropagation() : addProductCxone();"
								tabindex="0">
								<span cvLocalizedText langSection="MarketPlace_Management" langKey="New_Product">New
									Product</span>
							</button>
						</div>
					</div>
					<!-- end header -->
					<div class="row cxone-container">
						<div class="col-12 mb-2 mt-0">
							<div [hidden]="!(showOrders == false)">
								<div class="row">
									<!-- omnibar and search bar -->
									<sol-omnibar #filters class="w-100 marketplace-managment-omnibar" [itemCountLabel]="countProductsText"
										[isFilterable]="true" [searchPlaceholderText]="searchPlaceholder"
										(showFooterChanged)="toggleFilters()"
										(searchQueryChange)="onTitleFilterChange($event)">
										<!-- filters -->
										<sol-omnibar-filters>
											<div id="filters-container"
												class="d-flex justify-content-between row bg-light-blue-2">
												<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
													<label
														class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 "
														cvLocalizedText langSection="MarketPlace_Management"
														langKey="Category5">Category5</label>
													<sol-dropdown id="category-dropdown"
														class="w-100 mr-2" [optionsLabel]="'name'" [optionsValue]="'id'"
														[placeholder]="'Select category'" [(ngModel)]="selectedCategory"
														[options]="pscs.categoryList" [searchEnabled]="false"
														[showFooter]="false" (selectionChange)="categorySelected();scrollToTop()"
														>
													</sol-dropdown>
												</div>

												<div class="col-xs-12 col-sm-12 col-lg-3 col-md-3">
													<label
														class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 "
														cvLocalizedText langSection="MarketPlace_Management"
														langKey="SubCategory">SubCategory</label>
													<sol-dropdown id="subcategory-dropdown" class="w-100"
														[optionsLabel]="'name'" [optionsValue]="'id'"
														[placeholder]="'Select subcategory'" [(ngModel)]="selectedSubCategory"
														[options]="selectedSubCategories" [searchEnabled]="false" [showFooter]="false"
														(selectionChange)="assignSubCategoryToFilter();filterChanged();scrollToTop()"
														>
													</sol-dropdown>
												</div>

												<div
													class="col-xs-12 col-sm-12 col-lg-4 col-md-4 d-flex flex-wrap align-items-center">
													<div class="form-check form-check-inline">
														<sol-checkbox class="form-check-input" name="filterSale"
															id="filterSale" value="" type="checkbox"
															[(ngModel)]="pspes.pointStoreProductFilter.Sale"
															(ngModelChange)="filterChanged()">
														</sol-checkbox>
														<label
															class="form-check-label font-weight-400 font-size-13 line-height-18 color-black mt-2"
															for="filterSale"><span cvLocalizedText
																langSection="MarketPlace_Management"
																langKey="Discounted">Discounted</span></label>
													</div>

													<div class="form-check form-check-inline">
														<sol-checkbox class="form-check-input" name="filterFeatured"
															id="filterFeatured" value="" type="checkbox"
															[(ngModel)]="pspes.pointStoreProductFilter.Feature"
															(ngModelChange)="filterChanged()">
														</sol-checkbox>
														<label
															class="form-check-label font-weight-400 font-size-13 line-height-18 color-black mt-2"
															for="filterFeatured"><span cvLocalizedText
																langSection="MarketPlace_Management"
																langKey="Featured">Featured</span></label>
													</div>

													<div class="form-check form-check-inline">
														<sol-checkbox class="form-check-input" name="filterCarousel"
															id="filterCarousel" value="" type="checkbox"
															[(ngModel)]="pspes.pointStoreProductFilter.Carousel"
															(ngModelChange)="filterChanged()">
														</sol-checkbox>
														<label
															class="form-check-label font-weight-400 font-size-13 line-height-18 color-black mt-2"
															for="filterCarousel"><span cvLocalizedText
																langSection="MarketPlace_Management"
																langKey="Carousel">Carousel</span></label>
													</div>
												</div>
												<div class="action-btns col-md-2 col-lg-2 col-sm-12 col-xs-12 d-flex align-items-center justify-content-md-end justify-content-lg-end">
													<a class="pr-1" cvLocalizedText langSection="MarketPlace_Management" langKey="Clear_All" (click)="clearFilters()">Clear All</a>
													<a class="pl-1" cvLocalizedText langSection="MarketPlace_Management" langKey="Close" (click)="closeFilters()">Close</a>
												</div>
											</div>
										</sol-omnibar-filters>
										<!-- end filters -->
									</sol-omnibar>
									<!-- end omnibar and search bar -->
								</div>
								<div class="custom-row">
									<cv-point-store-product-landing-thumbnail
										[productList]="pspes.collection.originalData"
										[sortOptions]="sortOptions"
										(loadCountProducts)="loadCountProducts($event)"
										*ngIf="view == 0"></cv-point-store-product-landing-thumbnail>
								</div>
								<cv-point-store-product-landing-list
									*ngIf="pspes.collection.originalData != null && view == 1"></cv-point-store-product-landing-list>
								<!--<point-store-product-landing-list remove="removeListView();" ng-if="view == 1"></point-store-product-landing-list>-->
							</div>
							<!--<point-store-product-orders-admin-list ng-show="showOrders == true"></point-store-product-orders-admin-list>-->
						</div>
					</div>
				</div>
				<!-- end cxone container -->
			</div>
		</div>

		<!-- notification modal -->
		<ng-template #notificationModal let-modal>
			<div class="modal-header">
				<h7 class="modal-title d-flex justify-content-between" cvLocalizedText langSection="Common" langKey="Modal_Name">New
					Order Notification Recipients</h7>
				<button type="button" class="icon-btn fill-valyrianSteel-w-hover mt-n2 mr-n2"
					(click)="modal.dismiss('Cross click');clean();">
					<svg class="icon-16">
						<use href="../../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
					</svg>
				</button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-6"><span cvLocalizedText langSection="Common" langKey="Logins">Logins</span></div>
					<div class="col-6"><span cvLocalizedText langSection="Common" langKey="Selected">Selected</span>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div class="p-0 col-12 objectivesAssignBox"
							style="height:424px; border: 1px solid #DDDDDD;border-radius: 5px">
							<div class="search-box live-search">
								<input type="search" class="form-control" cvLocalizedPlaceholder langSection="Common"
									langKey="Search" [(ngModel)]="search" />
								<span class="clear-input" *ngIf="search.length > 0" (click)="search = ''"></span>
							</div>
							<cv-loader size="medium" [overlay]="false" *ngIf="isLoadingLogins"></cv-loader>
							<overlay-scrollbars [options]="scrollOptions" style="height:368px">
								<div *ngFor="let obj of loginUsers | filterText: search; let i = index"
									class="assignToolSingleButtonParent">
									<div class="FlexRowNoWrap itemContainer">
										<div class="objectiveItem txtOverflow">- {{obj.LoginName}}</div>
										<div class="FlexRowNoWrap">
											<div class="assignToolSingleButton FlexAlignVertical"
												(click)="onAddLoginUsers(i, obj)"></div>
										</div>
									</div>
								</div>
							</overlay-scrollbars>
						</div>
					</div>
					<div class="col-6">
						<overlay-scrollbars class="col-12 p-0 objectivesAssignBox" [options]="scrollOptions"
							style="height:424px; border: 1px solid #DDDDDD;border-radius: 5px">
							<div *ngFor="let obj of selectedLoginUsers; let i = index" class=" h-auto">
								<div class="FlexRowNoWrap itemContainer">
									<div class="objectiveItem txtOverflow">- {{obj.LoginName}}</div>
									<div class="removeHolder FlexRowNoWrap">
										<div class="removeIcon FlexAlignVertical" (click)="onRemoveLoginUsers(i, obj)">
										</div>
									</div>
								</div>
							</div>
						</overlay-scrollbars>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-text mr-2" (click)="modal.close('Close click');clean()"
					cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
				<button type="button" class="btn btn-primary" (click)="saveNotification()" cvLocalizedText
					langSection="Common" langKey="Save_Button">Save</button>
			</div>
		</ng-template>
		<!-- end notification modal -->
	</div>
</div>
